var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.dataList),function(list,index){return _c('md-anchor',{key:index},[_vm._v(" "+_vm._s(`${index + 1}、${list}`))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }